import Header from "@/components/Header";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="문의하기 - Central TG | JAX 모델 주문 및 상담"
        description="JAX transgenic 모델 주문, 견적 문의 및 전문 상담 서비스. 연구 목적에 맞는 최적의 모델을 제안해드립니다. 빠른 응답 보장."
        keywords="JAX 모델 주문, transgenic 마우스 견적, 실험동물 문의, 연구동물 상담, 모델 견적서, Central TG 연락처"
        canonical="https://centraltg.co.kr/contact"
      />
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;